import React, { useState, Fragment } from "react"
import { Modal, Form, Button } from "react-bootstrap"
import Loader from "./../shared/Loader"
import { createUnidad } from "../../services/admin.service"
import { toast } from "react-toastify"

const ModalFormUnidad = props => {
	const { show, setShow, tipos, setUnidades, unidad = {}, isEdit = false } = props
	const [loader, setLoader] = useState(false)
	const [dataForm, setDataForm] = useState({})

	const handleSubmit = async e => {
		e.preventDefault()

		if (noChangesEdit()) {
			toast.info("No se han hecho cambios")
			closeModal()
			return
		}

		setLoader(true)
		const res = (await isEdit)
			? await createUnidad(dataForm, unidad.id)
			: await createUnidad(dataForm)

		console.log(res)

		if (res?.response === "success") {
			setUnidades(res.data)
			toast.info("Unidad creada correctamente")
			closeModal()
		} else {
			toast.error(res?.message || "Error al crear unidad")
		}
		setLoader(false)
	}

	const noChangesEdit = () => {
		if (Object.keys(unidad).length === 0) return false

		const nombre = document.getElementById("nombre").value
		const cod = document.getElementById("cod").value
		const tipo = document.getElementById("tipo").value

		return (
			unidad.nombre === nombre &&
			unidad.cod.toString() === cod.toString() &&
			unidad.tipo_id.toString() === tipo.toString()
		)
	}

	const handleChange = e => {
		setDataForm({ ...dataForm, [e.target.name]: e.target.value })
	}

	const setOptionsSelect = () => {
		return tipos?.map(x => {
			return (
				<option key={x.id} value={x.id}>
					{x.nombre}
				</option>
			)
		})
	}

	const closeModal = () => {
		console.log("cerrando modal")
		setDataForm({})
		setShow(false)
		// setUnidadSelected({})
	}

	return (
		<Modal
			show={show}
			onHide={() => closeModal()}
			backdrop="static"
			keyboard={false}
			className="text-center"
		>
			<Modal.Header closeButton>
				<Modal.Title>{isEdit ? "Editar" : "Crear nueva"} Unidad</Modal.Title>
			</Modal.Header>
			<Form onSubmit={handleSubmit}>
				<Modal.Body className="px-2 py-4">
					Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iure earum optio a
					perspiciatis facere non sint incidunt veniam iste asperiores amet, itaque magnam
					<hr />
					<Form.Group className="px-5">
						<Form.Label>Código de unidad</Form.Label>
						<Form.Control
							id="cod"
							name="cod"
							type="number"
							required
							onChange={handleChange}
							defaultValue={unidad?.cod || ""}
						/>
					</Form.Group>
					<Form.Group className="px-5">
						<Form.Label>Nombre</Form.Label>
						<Form.Control
							id="nombre"
							name="nombre"
							type="text"
							defaultValue={unidad?.nombre || ""}
							required
							onChange={handleChange}
						/>
					</Form.Group>
					<Form.Group className="px-5">
						<Form.Label>Tipo</Form.Label>
						<Form.Control
							as="select"
							name="tipo"
							id="tipo"
							onChange={handleChange}
							required
							defaultValue={unidad?.tipo_id || ""}
						>
							<option value="" disabled>
								Seleccione
							</option>
							{setOptionsSelect()}
						</Form.Control>
					</Form.Group>
				</Modal.Body>
				<Modal.Footer>
					{loader ? (
						<Loader />
					) : (
						<Fragment>
							<Button
								variant="secondary"
								disabled={loader}
								onClick={() => {
									closeModal()
								}}
							>
								Volver
							</Button>
							<Button disabled={loader} variant="primary" type="submit">
								Guardar
							</Button>
						</Fragment>
					)}
				</Modal.Footer>
			</Form>
		</Modal>
	)
}

export default ModalFormUnidad
